// extracted by mini-css-extract-plugin
export default {"tupacGrid":"rm-z","tupacHeader":"sm-z","tupacHeader2":"tm-z","tupacMenu":"um-z","tupacMenu2":"vm-z","tupacMain":"wm-z","tupacMain2":"xm-z"};